import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from '../state.service';
import { AlertService } from '../alert.service';
import { ToastService } from '../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

import { AuthService } from '../auth.service';

const isDevMode = false;
let KIZUNACORE_API_URL = `https://care-ukc-api.cdc-iot.com`;
if (isDevMode) {
  KIZUNACORE_API_URL = `https://test-care-ukc-api.cdc-iot.com`;
}

@Injectable()
export class ApiDebugCareSystemService extends ApiBaseService {

  protected headers: Headers;
  isLoading: boolean = true;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
    public authService: AuthService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  getDebugHeader() {
    return new Headers({
      'Accept': 'application/json',
      'Content-type': 'application/json',
      'Accept-Language': 'ja,en-US;q=0.9,en;q=0.8',
    });
  }


  async kizunaCore(body: any = {}): Promise<any> {
    const url = `${KIZUNACORE_API_URL}/api/v1/sensor/debug/logs`;
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doPost({
        url, body,
        headers: this.getDebugHeader()
      }
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-debug-caresystem.service.ts